export enum EAdminLiquidityQueryKey {
  ADMIN_LIQUIDITY_ACCOUNTS = 'ADMIN_LIQUIDITY_ACCOUNTS',
}
